import { putStatusTransactionById } from '../api/putStatusTransactionById';

export const setPutStatusTransactionById = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await putStatusTransactionById(params);

            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}